import { render, staticRenderFns } from "./content-campaign-list.vue?vue&type=template&id=08fbbf3b"
import script from "./content-campaign-list.vue?vue&type=script&lang=ts"
export * from "./content-campaign-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports